import ForecastForReceipt from '@/customerForecastModule/pages/main.vue';
export default ForecastForReceipt;
